import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://www.cayda.io';
const DEFAULT_OG_IMAGE = `${BASE_URL}/og-image.png`;
const SITE_NAME = 'Cayda';
const DEFAULT_TITLE = 'Website Feedback Tool for Teams — Cayda';
const DEFAULT_DESC = 'Website feedback tool for teams. Click anywhere on your live site and leave a note: bugs, design feedback, content fixes. Invisible to visitors. Free plan.';

/**
 * Per-page head tags. `jsonLd` is an array of schema.org objects; subpages that
 * pass `path` + `title` automatically get a BreadcrumbList (Home → page).
 */
export default function SEOHead({ title, description, path, ogImage, ogTitle, jsonLd = [] }) {
  // Titles that already name the brand (e.g. "Cayda vs BugHerd") are used as-is.
  const fullTitle = title ? (title.includes(SITE_NAME) ? title : `${title} — ${SITE_NAME}`) : DEFAULT_TITLE;
  const desc = description || DEFAULT_DESC;
  const url = path ? `${BASE_URL}${path}` : BASE_URL;
  const image = ogImage || DEFAULT_OG_IMAGE;
  const socialTitle = ogTitle || fullTitle;

  const schemas = [...jsonLd];
  if (path && path !== '/' && title) {
    schemas.push({
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home', item: `${BASE_URL}/` },
        { '@type': 'ListItem', position: 2, name: title, item: url },
      ],
    });
  }

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={socialTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={SITE_NAME} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={socialTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />

      {schemas.map((s, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(s)}</script>
      ))}
    </Helmet>
  );
}
